import Button from "./../../../components/v6/Button";
import images from "../../../images";
import { cn } from "../../../Utils/helper";
import Item from "../../Stickers/Item";
import { ProgressBarXPProfile } from "./ProgressBarXPProfile";

export const ProfileCard = ({
  coinAmount,
  // dollarValue = "$3.00",
  onWithdraw,
  onAlbum,
  subTitle = "Rally Coins",
  className = "",
  currentXp,
  total,
  level,
  // imageCard,
  subPowerUpImage,
  subPowerUpImageSecond,
  onClickCard,
  stickers,
  iconName,
  itemClassName = "",
  contentContainerClassName = "",
}) => {
  return (
    <section
      onClick={onClickCard}
      className={cn(
        "flex flex-row justify-between mx-auto bg-[#ECEEFF] rounded-md max-md:my-0 max-md:w-full max-sm:w-full p-4 xs:p-6 w-full max-w-[480px] relative",
        className
      )}
    >
      <div
        className={cn(
          "flex flex-col justify-between flex-1 min-w-0 pr-3 max-w-[65%] gap-4 xs:gap-6",
          contentContainerClassName
        )}
      >
        {/* Header: Icon + Title */}
        <div className="flex flex-row gap-2 items-center">
          <span className={`icon icon-${iconName} text-[#253FF6]`} />
          <h6 className="text-[#253FF6] font-[Figtree] text-[14px] xs:text-[16px] font-bold not-italic leading-none">
            {subTitle}
          </h6>
        </div>

        {/* --- CASE 1: RALLY COINS --- */}
        {coinAmount !== undefined && coinAmount !== null && (
          <>
            <h1 className="text-[#253FF6] font-[Figtree] text-[46px] xs:text-[48px] font-bold not-italic leading-none tracking-[-0.96px] break-words word-break">
              {parseInt(coinAmount)}
            </h1>

            <span className="text-[#253FF6] font-[Figtree] text-[10px] xs:text-[12px] font-medium not-italic leading-none">
              100 Rally Coins = SGD 1.00
            </span>
          </>
        )}
        {/* --- CASE 2: POWER UP (Legacy code) --- */}
        {subPowerUpImage && subPowerUpImageSecond && (
          <div className="flex flex-row gap-2 items-center">
            <img src={subPowerUpImage} alt="" />
            <img src={subPowerUpImageSecond} alt="" />
          </div>
        )}

        {/* --- CASE 3: STICKERS (SỬ DỤNG ITEM REUSABLE) --- */}
        {stickers && stickers.length > 0 && (
          <div className="flex flex-row gap-3 items-center">
            {stickers.map((item) => (
              <div key={item.id}>
                <Item item={item} className={itemClassName} />
              </div>
            ))}
          </div>
        )}

        {/* --- CASE 4: EXPERIENCE POINTS --- */}
        {currentXp !== undefined && currentXp !== null && (
          <>
            <h1 className="text-[#253FF6] font-[Figtree] text-[46px] xs:text-[48px] max-w-[300px] font-bold not-italic leading-none tracking-[-0.96px]">
              {parseInt(currentXp)}
              <ProgressBarXPProfile currentXp={currentXp} total={total} />
            </h1>
            <div className="text-[10px] text-[#253FF6]">
              Earn <strong>{parseInt(total - currentXp)} XP</strong> more to{" "}
              <strong>Level {level + 1}</strong>
            </div>
          </>
        )}
      </div>

      {/* --- RIGHT SIDE BUTTONS --- */}
      <div className="flex flex-col-reverse justify-between items-end flex-shrink-0">
        {/* Button Withdraw */}
        {coinAmount !== undefined && coinAmount !== null && (
          <Button
            className="rounded-lg h-[50px] text-[18px] xs:text-xl font-medium text-white bg-[#253FF6] px-4"
            handleClick={() => onWithdraw && onWithdraw()}
          >
            Withdraw
          </Button>
        )}

        {/* Button Album */}
        {onAlbum && (
          <Button
            className="px-[18px] py-3 rounded-lg text-[18px] xs:text-xl font-medium text-white bg-[#253FF6]"
            handleClick={onAlbum}
          >
            Album
          </Button>
        )}
      </div>

      {/* XP Decoration Image */}
      {currentXp !== undefined && currentXp !== null && (
        <img src={images.XPProfileImage} alt="" />
      )}
    </section>
  );
};

export default ProfileCard;
